// Technology + implant-system information available THROUGH SELECTED PARTNER
// PROVIDERS. Framed carefully: Dentel Vietnam is not the clinic and does not own
// equipment. Availability varies by provider and treatment plan.

const L = (en, fr, de) => ({ en, fr, de });

export const TECHNOLOGY = [
  {
    icon: "ScanLine",
    title: L("3D CBCT / Cone Beam CT", "3D CBCT / Cone Beam CT", "3D-DVT / Cone-Beam-CT"),
    body: L(
      "3D CBCT imaging can help dental professionals assess jawbone volume and density, nerve and sinus position, impacted teeth and implant placement areas. It is commonly used when planning dental implants and complex restorative treatment.",
      "L’imagerie 3D CBCT peut aider les professionnels à évaluer le volume et la densité osseux, la position des nerfs et des sinus, les dents incluses et les zones de pose d’implants. Elle est courante pour planifier les implants et les traitements restaurateurs complexes.",
      "Die 3D-DVT-Bildgebung kann Fachkräften helfen, Knochenvolumen und -dichte, Nerven- und Sinuslage, verlagerte Zähne und Implantatregionen zu beurteilen. Sie wird häufig bei der Planung von Implantaten und komplexen Restaurationen genutzt."
    ),
  },
  {
    icon: "Crosshair",
    title: L("Dynamic Implant Navigation", "Navigation implantaire dynamique", "Dynamische Implantatnavigation"),
    body: L(
      "Dynamic navigation (X-Guide-type) can assist a trained implant dentist during suitable procedures by helping monitor planned implant position, angle, depth and relationship to surrounding anatomy.",
      "La navigation dynamique (type X-Guide) peut assister un dentiste formé lors d’interventions adaptées en aidant à suivre la position, l’angle, la profondeur de l’implant et son rapport à l’anatomie environnante.",
      "Die dynamische Navigation (X-Guide-Typ) kann einen geschulten Zahnarzt bei geeigneten Eingriffen unterstützen, indem sie Position, Winkel, Tiefe und Bezug zur umliegenden Anatomie überwachen hilft."
    ),
  },
  {
    icon: "Scan",
    title: L("Digital Intraoral Scanning", "Scan intra-oral numérique", "Digitaler Intraoralscan"),
    body: L(
      "Digital intraoral scanners (iTero Element 5D-type) create detailed digital impressions of teeth, gums, bite and dental arches, reducing reliance on conventional impression materials and supporting digital planning.",
      "Les scanners intra-oraux numériques (type iTero Element 5D) créent des empreintes numériques détaillées des dents, gencives, occlusion et arcades, réduisant le recours aux matériaux d’empreinte classiques et facilitant la planification numérique.",
      "Digitale Intraoralscanner (iTero-Element-5D-Typ) erstellen detaillierte digitale Abdrücke von Zähnen, Zahnfleisch, Biss und Zahnbögen, reduzieren klassische Abformmaterialien und unterstützen die digitale Planung."
    ),
  },
  {
    icon: "ScanFace",
    title: L("3D Facial Scanning", "Scan facial 3D", "3D-Gesichtsscan"),
    body: L(
      "3D facial scanning (RAYFace-type) can record facial proportions, lips, smile line and symmetry, and the relationship between the teeth and the face, supporting cosmetic and restorative planning.",
      "Le scan facial 3D (type RAYFace) peut enregistrer les proportions du visage, les lèvres, la ligne du sourire, la symétrie et le rapport entre les dents et le visage, pour la planification esthétique et restauratrice.",
      "Der 3D-Gesichtsscan (RAYFace-Typ) kann Gesichtsproportionen, Lippen, Lachlinie, Symmetrie und das Verhältnis von Zähnen zum Gesicht erfassen und die ästhetische sowie restaurative Planung unterstützen."
    ),
  },
  {
    icon: "Smile",
    title: L("Digital Smile Design", "Digital Smile Design", "Digital Smile Design"),
    body: L(
      "Digital Smile Design may let dentists and patients review proposed changes in tooth shape, proportions, smile line and overall appearance before appropriate cosmetic treatment begins. A digital preview is not identical to the final clinical result.",
      "Le Digital Smile Design peut permettre au dentiste et au patient de visualiser les changements proposés de forme, proportions, ligne du sourire et aspect global avant le traitement esthétique. L’aperçu numérique n’est pas identique au résultat clinique final.",
      "Digital Smile Design kann Zahnärzten und Patienten erlauben, vorgeschlagene Änderungen von Zahnform, Proportionen, Lachlinie und Gesamtbild vor einer ästhetischen Behandlung zu prüfen. Eine digitale Vorschau ist nicht identisch mit dem finalen klinischen Ergebnis."
    ),
  },
  {
    icon: "Activity",
    title: L("Digital Bite Analysis", "Analyse occlusale numérique", "Digitale Bissanalyse"),
    body: L(
      "Digital bite analysis (T-Scan Novus-type) can help clinicians assess tooth contact, timing of contact, biting-force distribution and bite imbalance — useful when planning complex restorative, implant or full-mouth treatment.",
      "L’analyse occlusale numérique (type T-Scan Novus) peut aider à évaluer les contacts dentaires, leur chronologie, la répartition des forces et les déséquilibres occlusaux — utile pour les traitements restaurateurs, implantaires ou complets complexes.",
      "Die digitale Bissanalyse (T-Scan-Novus-Typ) kann Kontaktpunkte, deren Timing, Kaukraftverteilung und Fehlbisse beurteilen helfen — nützlich bei komplexen restaurativen, implantologischen oder Vollkiefer-Behandlungen."
    ),
  },
  {
    icon: "Cpu",
    title: L("CAD/CAM Digital Dentistry", "Dentisterie numérique CAD/CAM", "CAD/CAM-Digitalzahnheilkunde"),
    body: L(
      "CAD/CAM technology allows restorations — crowns, bridges, veneers and implant restorations — to be digitally designed and manufactured. Selected providers may operate an in-house laboratory, which can make communication, adjustments and turnaround more efficient. Some restorations may be produced more quickly depending on the case, material and provider workflow.",
      "La technologie CAD/CAM permet de concevoir et fabriquer numériquement des restaurations — couronnes, bridges, facettes et restaurations sur implants. Certains prestataires disposent d’un laboratoire interne, ce qui peut rendre communication, ajustements et délais plus efficaces. Certaines restaurations peuvent être réalisées plus rapidement selon le cas, le matériau et le flux du prestataire.",
      "Die CAD/CAM-Technologie ermöglicht das digitale Design und die Fertigung von Restaurationen — Kronen, Brücken, Veneers und Implantatversorgungen. Ausgewählte Anbieter betreiben ggf. ein eigenes Labor, was Kommunikation, Anpassungen und Durchlaufzeiten effizienter machen kann. Manche Restaurationen können je nach Fall, Material und Ablauf schneller gefertigt werden."
    ),
  },
  {
    icon: "Zap",
    title: L("Dental Laser Technology", "Technologie laser dentaire", "Dentale Lasertechnologie"),
    body: L(
      "Dental lasers (LightWalker-type) may be used for selected periodontal, soft-tissue and dental treatment applications. Suitability depends on the dentist and the clinical indication.",
      "Les lasers dentaires (type LightWalker) peuvent être utilisés pour certaines applications parodontales, sur tissus mous et dentaires. L’indication dépend du dentiste et du contexte clinique.",
      "Dentallaser (LightWalker-Typ) können für ausgewählte parodontale, Weichgewebe- und zahnärztliche Anwendungen genutzt werden. Die Eignung hängt vom Zahnarzt und der klinischen Indikation ab."
    ),
  },
  {
    icon: "Waypoints",
    title: L("Endodontic / Root Canal Technology", "Technologie endodontique / canalaire", "Endodontie-/Wurzelkanaltechnik"),
    body: L(
      "Modern integrated endodontic systems can assist dentists with root canal preparation, measurement, cleaning and treatment control.",
      "Les systèmes endodontiques intégrés modernes peuvent aider les dentistes pour la préparation, la mesure, le nettoyage et le contrôle du traitement canalaire.",
      "Moderne integrierte Endodontie-Systeme können Zahnärzte bei Aufbereitung, Messung, Reinigung und Kontrolle der Wurzelbehandlung unterstützen."
    ),
  },
  {
    icon: "CircleDot",
    title: L("Implant Surface Technology", "Technologie de surface implantaire", "Implantatoberflächen-Technologie"),
    body: L(
      "Where used by selected providers, implant surface-treatment technology relates to the finish of the implant surface. This is described in general terms only.",
      "Lorsqu’elle est utilisée par certains prestataires, la technologie de traitement de surface concerne la finition de la surface de l’implant. Elle est décrite en termes généraux uniquement.",
      "Sofern von ausgewählten Anbietern eingesetzt, betrifft die Oberflächenbehandlungstechnologie die Beschaffenheit der Implantatoberfläche. Sie wird nur allgemein beschrieben."
    ),
  },
];

export const IMPLANT_SYSTEMS = [
  "Straumann", "Neodent", "Dentium SuperLine", "Hiossen", "Biotem", "NTA", "Ken",
];

export const IMPLANT_SELECTION_NOTE = L(
  "Implant selection depends on your clinical condition, bone quality, treatment type, dentist recommendation, budget and restorative requirements. Not every provider stocks every brand.",
  "Le choix de l’implant dépend de votre état clinique, de la qualité osseuse, du type de traitement, de la recommandation du dentiste, du budget et des exigences prothétiques. Tous les prestataires ne disposent pas de toutes les marques.",
  "Die Implantatauswahl hängt von Ihrem klinischen Zustand, der Knochenqualität, der Behandlungsart, der Empfehlung des Zahnarztes, dem Budget und den prothetischen Anforderungen ab. Nicht jeder Anbieter führt jede Marke."
);

export const IMPLANT_QUESTIONS = L(
  [
    "Which implant system is being recommended, and why is it appropriate for my case?",
    "What implant documentation will I receive (reference or serial information)?",
    "What warranty applies and what does it cover?",
    "Are replacement components internationally available?",
    "What follow-up is recommended?",
  ],
  [
    "Quel système d’implant est recommandé et pourquoi convient-il à mon cas ?",
    "Quelle documentation d’implant recevrai-je (référence ou numéro de série) ?",
    "Quelle garantie s’applique et que couvre-t-elle ?",
    "Les composants de remplacement sont-ils disponibles à l’international ?",
    "Quel suivi est recommandé ?",
  ],
  [
    "Welches Implantatsystem wird empfohlen und warum passt es zu meinem Fall?",
    "Welche Implantatdokumentation erhalte ich (Referenz- oder Seriennummer)?",
    "Welche Garantie gilt und was deckt sie ab?",
    "Sind Ersatzkomponenten international verfügbar?",
    "Welche Nachsorge wird empfohlen?",
  ]
);

export const TECH_HEADING = L(
  "Advanced dental technology available through selected providers",
  "Technologies dentaires avancées disponibles chez des prestataires sélectionnés",
  "Fortschrittliche Zahntechnik bei ausgewählten Anbietern verfügbar"
);

export const TECH_SUB = L(
  "Technology available through selected Dentel Vietnam partner providers may include the following. Availability varies by provider and treatment plan.",
  "Les technologies disponibles chez les prestataires partenaires sélectionnés de Dentel Vietnam peuvent inclure les éléments suivants. La disponibilité varie selon le prestataire et le plan de traitement.",
  "Zu den bei ausgewählten Dentel-Vietnam-Partneranbietern verfügbaren Technologien können die folgenden gehören. Die Verfügbarkeit variiert je nach Anbieter und Behandlungsplan."
);
